var sandbox = {
    activityTab: {
        activity: 'Actividad',
        date: 'Fecha',
        description: 'Descripción',
        amount: 'Monto'
    },
    promotions: {
        noPromotions: 'No tiene promociones en este momento'
    },
    accountInfo: {
        accountEndingIn: 'Cuenta que termina en {{accountLast4}}',
        accountServices: 'Servicios de Cuentas',
        activity: 'Actividad',
        availableToSpend: 'Disponible para gastar',
        currentBalance: 'Saldo Actual',
        dueDate: 'Fecha de pago',
        makeAPayment: 'Realizar un pago',
        totalMinimumPayment: 'Total del Pago mínimo'
    },
    accountDashboard: {
        autoPay: 'Pago automático',
        available: 'Disponible para gastar',
        details: 'Detalles',
        mayNotReflect: 'Podría no reflejar transacciones recientes.',
        more: 'Más',
        off: 'Desactivado',
        statements: 'Estados De Cuenta'
    },
    activitySidebar: {
        promotions: 'Promociones'
    },
    alerts: {
        balanceAlerts: 'Alertas de Saldo',
        balanceAlertsAvailableCredit: 'El crédito disponible se encuentra dentro del límite de crédito de $_____',
        balanceAlertsExceedsCreditLimit: 'El saldo supera el límite de crédito',
        balanceAlertsExceedsValue: 'El saldo supera $_____',
        buttonInfo: 'Actualizar teléfono o correo electrónico',
        contactInfo: 'Información de Contacto',
        contactMessage: 'Reciba alertas por correo electrónico y mensaje de texto con acciones importantes en su cuenta. Se enviarán alertas a la dirección de correo electrónico y número de teléfono en su perfil.',
        emailAddressContent: 'M***********A@S*F.COM',
        emailAddressTitle: 'Dirección de Correo Electrónico',
        paymentAlerts: 'Alertas de Pagos',
        paymentAlertsAutoPay: 'El pago o el pago automático vence en {{paymentNumberOfDays}} días',
        paymentAlertsPromoPurchase: 'La compra promocional vencerá en _____ días',
        phoneNumberContent: 'No hay número en el archivo',
        phoneNumberTitle: 'Numero de teléfono',
        securityInformation: 'Alertas de Seguridad',
        securityInformationTagline: 'Por su seguridad, siempre recibirá un correo electrónico para las siguientes alertas y estas no se podrán desactivar.',
        spendingAlerts: 'Alertas de Gastos',
        spendingAlertsApproved: 'Transacciones aprobadas',
        spendingAlertsCredit: 'Se registró un crédito o reembolso',
        spendingAlertsDeclined: 'Transacciones rechazadas',
        switchOff: 'DESACTIVAR',
        switchOn: 'ACTIVAR',
        title: 'Administrar Alertas'
    },
    personalGreeting: {
        morning: 'Buenos Días',
        afternoon: 'Buenas Tardes',
        evening: 'Buenas Noches'
    },
    services: {
        accountServices: 'Servicios de Cuentas',
        creditLimitIncrease: 'Aumento del límite de crédito',
        changePaymentDate: 'Cambiar fecha de vencimiento de pago',
        activateCard: 'Activar una tarjeta',
        freezeCard: 'Congelar tarjeta',
        replaceYourCard: 'Reemplazar su tarjeta',
        reportLost: 'Reportar tarjeta perdida o robada',
        manageTravelPlans: 'Gestionar notificaciones de viaje',
        createPIN: 'Crear/cambiar PIN',
        cardActions: 'Acciones de Tarjeta',
        security: 'Seguridad',
        accountActions: 'Acciones de Cuenta',
        manageCardHolders: 'Administrar titulares de tarjetas'
    }
};
export default sandbox;
//# sourceMappingURL=sandbox.js.map